<template lang="html">
  <div class="main" ref="main">
    <component
      :is="moduleId"
      :info="enterInfo"
      :stepNo="stepNo"
      v-if="!hasErr"
    ></component>
    <empty v-else text="系统异常" />
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import empty from '@/components/common/empty'

export default {
  data() {
    return {
      uid: '',
      skey: '',
      puid: '',
      stepNo: 0,
      moduleId: '',
      shareInfo: {
        title: '快速入驻孩子王认证育儿师',
        desc: '让你轻松接单不烦恼，服务收益最大化，提前实现财务自由',
        link: 'https://life.cekid.com/v/yuesao/step0?refresh=no'
      },
      hasErr: false
    }
  },
  async beforeCreate() {
    try {
      const { uid, skey } = await this.$$ensureLogin()
      this.uid = uid
      this.skey = skey
      const tkey = this.$route.query.hserecomkey || ''
      const managerUid = this.$route.query.puid || ''
      await this.$store.dispatch('getEnterInfo', {
        uid,
        tkey,
        skey,
        managerUid
      })
      const config = await this.$store.dispatch('getMainConfig')
      this.shareInfo = Object.assign(
        this.shareInfo,
        config.data.rewardShareInfo
      )
      const arr = ['settled_step_one', 'pre_step_two', 'fail']
      this.stepNo = this.enterInfo.status - 0 || 0
      if (this.stepNo >= 1) {
        this.stepNo = 1
      }
      const params_stepNo = this.$route.params.stepNo - 0
      const reSign = this.$route.query.resign || false
      if (reSign && params_stepNo === 0) {
        this.stepNo = 0
      }
      // if (this.enterInfo.validate === 1) {
      //     this.stepNo = 2
      // }
      this.moduleId = arr[this.stepNo]
      const component = () =>
        import(`../../components/entering/${this.moduleId}`)
      const components = []
      components[this.moduleId] = component
      this.$options.components = components
      this.$$share(this.shareInfo)
    } catch (e) {
      console.log(e.message)
      if (e.message === '4') {
        this.$$login()
      } else {
        this.hasErr = true
      }
    }
  },
  computed: {
    ...mapState(['enterInfo'])
  },
  components: {
    empty
  }
}
</script>

<style lang="scss" scoped>
.main {
  background-color: #f4f4f4;
}
</style>
